import React from "react";

import clsx from "clsx";

import type { InputProps } from "@busbud/horizon";
import { Button, Input } from "@busbud/horizon";

interface Props {
  loading: boolean;
  onRedeem: (evt: React.MouseEvent) => void;
  button_label: string;
  inputProps: InputProps;
  has_error?: boolean;
  error_text?: string;
  className?: string;
}

export const DISCOUNT_CODE_SUBMIT_BTN_ID = "discount-code-submit";

export const CreditsToRedeemLayout: React.FC<Props> = ({
  button_label,
  loading,
  inputProps,
  has_error = false,
  error_text,
  onRedeem,
  className
}) => {
  return (
    <Input
      className={clsx("w-full", className)}
      size="sm"
      type="text"
      isDisabled={loading}
      slotEnd={
        <Button
          appearance="primary"
          variant="text"
          size="sm"
          onClick={onRedeem}
          isDisabled={loading}
          className="whitespace-nowrap"
          data-testid={DISCOUNT_CODE_SUBMIT_BTN_ID}
        >
          {button_label}
        </Button>
      }
      errorText={error_text}
      isInvalid={has_error}
      {...inputProps}
    />
  );
};
